import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {v4 as uuidv4} from 'uuid';
import {orgId, defaultErrorHandler} from '../../../context/context';
import Section from '../../../libs/react-components-admin/section/section';
import SubSection from '../../../libs/react-components-admin/section/sub-section';
import NamedIntegrations from '../../../libs/react-components-admin/integration/named-integrations';
import recaptchaV1Client from '../../../infrastructure/acerill/recaptcha-v1-client';
import customFormsV2Client from '../../../infrastructure/acerill/custom-forms-v2-client';
import IntegrationOnlyForStandalone from '../common/integration-only-for-standalone';

const Recaptcha = () => {

  const navigate = useNavigate();

  const [keyPairs, setKeyPairs] = useState();

  useEffect(() => {
    recaptchaV1Client
      .findKeyPairs()
      .then(keyPairs => setKeyPairs((keyPairs || [])
        .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
      ))
      .catch(defaultErrorHandler);
  }, []);

  const createKeyPair = version => {
    return goToKeyPair(uuidv4(), version);
  };

  const goToKeyPair = (id, version) => {
    navigate('/integrations/recaptcha/' + encodeURIComponent(id) + '?shop=' + encodeURIComponent(orgId) + '&key_version=' + version);
    return new Promise(resolve => setTimeout(() => {resolve();}, 3000));
  };

  const deleteKeyPair = id => {
    return customFormsV2Client
      .deleteRecaptchaKeyPair(id)
      .then(() => setKeyPairs(prevKeyPairs => prevKeyPairs.filter(kp => kp.id !== id)));
  };

  return <Section title="Integration - reCAPTCHA" noMargin={true}>
    <div className="row justify-content-center">
      <div className="col-12 col-md-8">
        <IntegrationOnlyForStandalone/>
        {keyPairs &&
          <>
            <SubSection title="V2 Keys" className="mb-4">
              <NamedIntegrations integrations={keyPairs.filter(kp => kp.version === 'v2')}
                                 createAction={() => createKeyPair('v2')}
                                 editAction={id => goToKeyPair(id)}
                                 deleteAction={id => deleteKeyPair(id)}
                                 errorHandler={defaultErrorHandler}/>
            </SubSection>
            <SubSection title="V3 Keys" className="mb-4">
              <NamedIntegrations integrations={keyPairs.filter(kp => kp.version !== 'v2')}
                                 createAction={() => createKeyPair('v3')}
                                 editAction={id => goToKeyPair(id)}
                                 deleteAction={id => deleteKeyPair(id)}
                                 errorHandler={defaultErrorHandler}/>
            </SubSection>
          </>
        }
      </div>
    </div>
  </Section>;
};

export default Recaptcha;
